<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters" />
        <div class="triggers">
          <el-button type="primary" size="mini" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" size="mini" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          <el-button type="primary" size="mini" @click="uploadHandler">{{ $t('CargoMsg.Cargo_Upload') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
        />
      </div>
    </div>
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showEditDialog"
      :title="title"
      inline-message
      width="600px"
    >
      <el-form
        :model="form"
        label-width="150px"
        label-position="right"
      >
        <el-form-item :label="$t('SystemMaintenance.CloudStorageID')">
          <el-input v-model="form.storageId" size="mini" disabled />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.TemplateName')">
          <el-input v-model="form.templateName" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.Remark')">
          <el-input v-model="form.remarks" size="mini" />
        </el-form-item>
        <el-form-item label="SchemaType">
          <el-input v-model="form.schemaType" size="mini" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitHandler">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as templateApi from '@/api/sysManage/baseConfig/template'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'InitTemplateManage',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      fullscreenLoading: false,
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.TemplateFileCloudStorage'),
          field: 'storageId',
          width: 250
        }, {
          headerName: this.$t('SystemMaintenance.TemplateName'),
          field: 'templateName'
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks'
        }, {
          headerName: '数据源',
          field: 'schemaType',
          width: 200
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      showEditDialog: false,
      title: '',
      form: {
        storageId: '',
        templateName: '',
        remarks: '',
        schemaType: ''
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      const loading = getLoading()
      templateApi.queryInitTempaltes().then(resp => {
        this.rowData = resp.data
      }).finally(() => loading.close())
    },
    uploadHandler() {
      // Flash也是空方法
    },
    editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning('请选择需要编辑的模板！')
        return
      }
      Object.assign(this.form, selectedRow)
      this.title = this.$t('CargoMsg.Cargo_Edit')
      this.showEditDialog = true
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseTemplateYouWantDelete'))
        return
      }
      await this.$confirm(this.$t('SystemMaintenance.ConfirmDeletionOfThisTemplate'), this.$t('common.tips.confirm'), {
        closeOnClickModal: false,
        type: 'info'
      })
      const loading = getLoading()
      templateApi.remove(node.data.uuid).then(resp => {
        this.removeResultHandler(resp)
      }).finally(() => loading.close())
    },
    removeResultHandler(resp) {
      const res = resp.data
      if (res > 0) {
        this.$message.success(this.$t('SystemMaintenance.TemplateDeletedSuccessfully'))
      } else {
        this.$message.error(this.$t('SystemMaintenance.TemplateDeletionFailed'))
      }
      this.loadData()
    },
    submitHandler() {
      // 保存
      const loading = getLoading()
      templateApi.save(this.form).then(resp => {
        this.saveResultHandler(resp)
        this.loadData()
      }).finally(() => loading.close())
    },
    saveResultHandler(resp) {
      const result = resp.data
      if (result <= 0) {
        this.$message.warning(this.$t('SystemMaintenance.BasicFailedPleaseTryAgain'))
      } else {
        this.$message.success(this.$t('SystemMaintenance.BasicTemplateUpdateSuccessful'))
        this.cancelHandler()
      }
    },
    cancelHandler() {
      this.showEditDialog = false
      this.form = {
        storageId: '',
        templateName: '',
        remarks: '',
        schemaType: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
